/**
 * Catalog money helpers for Stripe `unit_amount` values (smallest currency
 * unit). Thin wrappers over the shared money helpers — the zero-decimal
 * table and parsing rules live in `shared/lib/money.ts` (single source of
 * truth), so catalog stays in sync with subscriptions and finance.
 */
import { formatMinorUnits, majorStringToMinorUnits } from "@/shared/lib/money";

export function formatMoney(unitAmount: number | null, currency: string): string {
  return formatMinorUnits(unitAmount, currency);
}

export function unitAmountFromMajorString(input: string, currency: string): number | null {
  return majorStringToMinorUnits(input, currency);
}
